import "./index.css";
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App';
import reportWebVitals from './webVitals/reportWebVitals';
import { MsalProvider } from '@azure/msal-react';
import pubClApp from "./app/hooks/usePubClApp";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

const AppWithAuthentication = () => (
    <React.StrictMode>
        <MsalProvider instance={pubClApp}>
            <App />
            <ToastContainer />
        </MsalProvider>
    </React.StrictMode>
);

root.render(<AppWithAuthentication />);



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(logger.info))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
